import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" className="prefix__bi prefix__bi-twitter-x" height={32} width={32}><path d="M25.2 1.5h4.908l-10.72 12.284L32 30.5h-9.874l-7.734-10.14-8.85 10.14H.632l11.466-13.14L0 1.5h10.126l6.99 9.266L25.202 1.5zm-1.72 26.056h2.72L8.646 4.29H5.73z" /></svg>;
}
export default SvgComponent;